import React, { useState } from "react"
import { Form, Modal } from "react-bootstrap"
import { UpdateListParams, useUpdateList } from "../hooks/useUpdateList"
import { toast } from "react-toastify"
import { isAxiosError } from "axios"

export interface VesselTrackingEditListModalProps {
  listID: string
  showEdit: boolean
  setShowEdit: React.Dispatch<React.SetStateAction<boolean>>
  fetchVesselTrackingList: () => Promise<void>
}

function VesselTrackingEditListModal({
  listID,
  showEdit,
  setShowEdit,
  fetchVesselTrackingList,
}: VesselTrackingEditListModalProps) {
  const { updateList, isUpdateListLoading } = useUpdateList()
  const [listName, setListName] = useState<string>("")
  //handle updatelist
  const handleUpdateList = async (listName: string) => {
    if (isUpdateListLoading) return
    try {
      const uList: UpdateListParams = {
        listName: listName,
        id: listID,
      }
      await updateList(uList)
      toast.success("List updated successfully", {
        position: "bottom-right",
        autoClose: 8000,
      })
    } catch (err: unknown) {
      const message = "Unable to update list"
      console.error(message, err)
      if (isAxiosError(err)) {
        toast.error(message, {
          position: "bottom-right",
          autoClose: 8000,
        })
      }
    } finally {
      setShowEdit(false)
      await fetchVesselTrackingList()
    }
  }
  return (
    <Modal show={showEdit} onHide={() => setShowEdit(false)} centered>
      <Modal.Header closeButton>
        <Modal.Title>Edit List</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* Add form or components to edit the list here */}
        <Form>
          <Form.Label>List Name</Form.Label>
          <Form.Control
            type="text"
            value={listName}
            onChange={(e) => setListName(e.target.value)}
            placeholder="Enter list name"
            required
          />
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={() => setShowEdit(false)}
          disabled={isUpdateListLoading}
        >
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => handleUpdateList(listName)}
          disabled={isUpdateListLoading || !listName.trim()}
        >
          {isUpdateListLoading ? (
            <span
              className="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
          ) : (
            "Save Changes"
          )}
        </button>
      </Modal.Footer>
    </Modal>
  )
}

export default VesselTrackingEditListModal
